import { useTranslation } from "react-i18next";

function Footer() {
    const { t } = useTranslation();

    return (
        <div className="container">
            <footer className="py-3 my-4">
                <ul className="nav justify-content-center border-bottom pb-3 mb-3">
                    <li className="nav-item">
                        <a href="/" className="nav-link px-2 text-muted">{t('footer.home')}</a>
                    </li>
                    <li className="nav-item">
                        <a href="/wordpress" className="nav-link px-2 text-muted">{t('footer.ecommerce_plugin')}</a>
                    </li>
                    <li className="nav-item">
                        <a href="/terms-of-service" className="nav-link px-2 text-muted">{t('footer.terms_of_service')}</a>
                    </li>
                    <li className="nav-item">
                        <a href="/privacy-policy" className="nav-link px-2 text-muted">{t('footer.privacy_policy')}</a>
                    </li>
                    <li className="nav-item">
                        <a href="/contact" className="nav-link px-2 text-muted">{t('footer.contact')}</a>
                    </li>
                    <li className="nav-item">
                        <a href="/faqs" className="nav-link px-2 text-muted">{t('footer.faqs')}</a>
                    </li>
                    <li className="nav-item">
                        <a href="/about" className="nav-link px-2 text-muted">{t('footer.about')}</a>
                    </li>
                </ul>
                <p className="text-center text-muted">&copy; {new Date().getFullYear()} Pagado, Inc</p>
            </footer>
        </div>
    );
}

export default Footer;
